import { isFunction } from "lodash-es";
import React from "react";
import { NavItem, NavLink } from "reactstrap";
import { classnames } from "../../utils/text";

const Tab = (props) => {
  const { actived, active, value, action, label, idx, disabled } = props;
  return (
    <NavItem>
      <NavLink
        className={classnames({
          active: isFunction(active)
            ? active(props)
            : actived === (value || idx),
        })}
        onClick={() => {
          action(value || idx, value, idx);
        }}
        disabled={disabled}
      >
        {label}
      </NavLink>
    </NavItem>
  );
};

const TabList = ({ tabList, active, className }) => {
  return (
    <ul className={classnames(`nav nav-tabs`, className)} role="tablist">
      {tabList.map((tab, idx) => (
        (isFunction(tab.isHide) && tab.isHide()) ||
          (!isFunction(tab.isHide) && tab.isHide) ?
          <React.Fragment key={`hide-tab-${idx}`}></React.Fragment>
          :
          <React.Fragment key={idx}>
            <Tab actived={active} idx={idx} {...tab} />
          </React.Fragment>
      ))}
    </ul>
  );
};

export { TabList, Tab };

export default TabList;
